export function openBusinessDashboard() {
  return window.navBiz?.();
}
